import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  update(event) {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set('time_range', event.target.value)

    Turbo.visit(`${window.location.pathname}?${searchParams.toString()}`, { action: "replace" })
  }
}